import React, { useEffect, useRef } from "react";
import { getReadableTextColor } from "../../../app/formatters/ColorFormatter";
import RpaPlanningScheduleGrid from "./RpaPlanningScheduleGrid";
import { getLocationUrl, getShowHrefUrl } from "./RpaUrlHelper";

/** @typedef {import('../controllers/RpaController.js').FilterObj } FilterObj */
/** @typedef {import('../../../app/models/UserModel.js').UserItem } UserItem */
/** @typedef {import('../../../app/models/CloseDayModel.js').CloseDayItem } CloseDayItem */
/** @typedef {import('../models/RpaResourceModel.js').RpaResourceItem } RpaResourceItem */
/** @typedef {import('../services/RpaPlanningService.js').ModifiedRpaResourceItem } ModifiedRpaResourceItem */

/**
 * @typedef {object} RpaPlanningResourceParams
 * @property {FilterObj} filter
 * @property {ModifiedRpaResourceItem} rpaResource
 * @property {boolean} transportAndParkingOption
 * @property {string} view
 * @property {boolean} cellheightWithGridScheduleOption
 * @property {Array<CloseDayItem>} closeDays
 * @property {boolean} showScheduleEndHourOption
 * @property {boolean} showAvailableReservationsOption
 * @property {boolean} showFirstReservationOnCaseOption
 * @property {boolean} showNbTotalPersonsOption
 * @property {?UserItem} connectedUser
 * @property {string} dayStr
 */

/**
 * @param {RpaPlanningResourceParams} props
 */
export default function RpaPlanningResource({ rpaResource, transportAndParkingOption, filter, view, cellheightWithGridScheduleOption, closeDays, showScheduleEndHourOption, showAvailableReservationsOption, showFirstReservationOnCaseOption, showNbTotalPersonsOption, connectedUser, dayStr }) {
  var addButtonRef = useRef(),
    returnUrl = `/rpa/_index?dayDateStr=${filter.dayDateStr}`;

  useEffect(() => {
    if (addButtonRef.current) {
      // @ts-ignore
      /** @type {import('../../../jsdoc/bottom.jsdoc.js').GwView}*/ (addButtonRef.current).gwView = new Button(addButtonRef.current);
    }
  }, [addButtonRef.current]);

  return (
    <div className="resaplan__activity">
      <h5 className="resaplan__activity-title" style={rpaResource.color ? { backgroundColor: rpaResource.color, color: getReadableTextColor(rpaResource.color) } : {}}>
        {view === "back" ? (
          <a className="resaplan__activity-title-name" data-tooltip="Voir toute les réservations de la journée" href={getShowHrefUrl(dayStr, rpaResource)} style={rpaResource.color ? { color: getReadableTextColor(rpaResource.color) } : {}}>
            {rpaResource.name}
          </a>
        ) : (
          <p className="resaplan__activity-title-name">{rpaResource.name}</p>
        )}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          {rpaResource.optionsSummary && rpaResource.optionsSummary.length ? (
            <gw-modal data-modaltitle="Options" data-buttonicon="package_2" data-buttontooltip="Option(s) choisie(s)" data-width="450">
              {rpaResource.optionsSummary.map((option, index) => (
                <p key={index} className="resaplan__activity-sub-title-name">
                  {option.name} : {option.quantity}
                </p>
              ))}
            </gw-modal>
          ) : (
            ""
          )}
          {transportAndParkingOption && view === "back" ? (
            <div className="resaplan__activity-title-buttons">
              <a data-loader="true" className="resaplan__case-btn" data-tooltip="Matériel de location" href={getLocationUrl(filter.dayDateStr, rpaResource)}>
                <span className="material-icons">inventory_2</span>
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
      </h5>

      {rpaResource.scheduleGridsOfCurrentDay.map(rpaScheduleGrid => (
        <RpaPlanningScheduleGrid key={rpaScheduleGrid.id} rpaResource={rpaResource} rpaScheduleGrid={rpaScheduleGrid} filter={filter} cellheightWithGridScheduleOption={cellheightWithGridScheduleOption} closeDays={closeDays} transportAndParkingOption={transportAndParkingOption} showScheduleEndHourOption={showScheduleEndHourOption} showAvailableReservationsOption={showAvailableReservationsOption} showFirstReservationOnCaseOption={showFirstReservationOnCaseOption} showNbTotalPersonsOption={showNbTotalPersonsOption} view={view} connectedUser={connectedUser} dayStr={dayStr} />
      ))}

      {view === "back" && connectedUser && connectedUser.right <= 1 ? (
        <>
          <div className="space--8"></div>
          <button
            className="btn btn--no-label btn--full has-more-actions"
            // @ts-ignore
            ref={addButtonRef}>
            <span className="material-icons">add</span>
            Ajouter
            <span className="material-icons">arrow_drop_down</span>
            <div className="menu">
              <ul>
                <li>
                  <a href={`/_add/rpa-schedule-grid?rpaGridId=${rpaResource.rpaGridId}&repeat_each_week=0&date=${rpaResource.dayDateStr}&onlyfields=start_hour,end_hour,title,price_type,reservation_type&forcereturnurl=${returnUrl}`}>Uniquement aujourd'hui</a>
                </li>
                <li>
                  <a href={`/_add/rpa-schedule-grid?rpaGridId=${rpaResource.rpaGridId}&repeat_each_week=1&date=${rpaResource.dayDateStr}&onlyfields=start_hour,end_hour,title,price_type,reservation_type&forcereturnurl=${returnUrl}`}>Tous les {rpaResource.dayWeekStr}</a>
                </li>
              </ul>
            </div>
          </button>
        </>
      ) : (
        ""
      )}
    </div>
  );
}
